import styled from 'styled-components';
import { IonCardHeader } from '@ionic/react';

export const Root = styled(IonCardHeader)`
  padding-bottom: ${({ theme: { spacing } }) => spacing(1)};
`;
